import { useState, useEffect, useRef } from "react";
import "../components/Advance/IncentivesAdvances.css";
import MonthPicker from "../components/MonthPicker/index.js";

const C = {
  bg: "var(--bg-page)",
  surface: "var(--bg-card)",
  elevated: "var(--pay-surface-2)",
  accent: "var(--primary)",
  accentHover: "var(--primary-hover)",
  muted: "var(--text-muted)",
  success: "var(--color-success)",
  warning: "var(--color-warning)",
  error: "var(--color-danger)",
  border: "var(--border)",
  borderAccent: "rgba(134,96,248,0.2)",
};

const s = {
  card: {
    background: "var(--bg-card)",
    border: "1px solid var(--border)",
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
  },
  elevated: {
    background: "var(--pay-surface-2)",
    border: "1px solid var(--border)",
    borderRadius: 8,
  },
  btnPrimary: {
    background: "var(--primary)",
    color: "#fff",
    padding: "10px 22px",
    borderRadius: 24,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
   fontSize: 12,
    fontFamily: "var(--font)",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    boxShadow: "0 4px 15px rgba(134,96,248,0.35)",
    transition: "all 0.2s",
  },
  btnSecondary: {
    background: "rgba(169,163,201,0.1)",
    color: "var(--text-primary)",
    padding: "9px 18px",
    borderRadius: 24,
    fontWeight: 500,
    border: "1px solid var(--border)",
    cursor: "pointer",
   fontSize: 12,
    fontFamily: "var(--font)",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    transition: "all 0.2s",
  },
  btnGhost: {
    background: "transparent",
    color: "var(--text-muted)",
    padding: "8px 14px",
    borderRadius: 20,
    fontWeight: 500,
    border: "1px solid var(--border)",
    cursor: "pointer",
    fontSize: 12,
    fontFamily: "var(--font)",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    transition: "all 0.2s",
  },
  btnSuccess: {
    background: "rgba(74,222,128,0.1)",
    color: "var(--color-success)",
    padding: "7px 14px",
    borderRadius: 18,
    fontWeight: 500,
    border: "1px solid rgba(74,222,128,0.25)",
    cursor: "pointer",
    fontSize: 12,
    fontFamily: "var(--font)",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  btnDanger: {
    background: "rgba(239,68,68,0.1)",
    color: "var(--color-danger)",
    padding: "7px 14px",
    borderRadius: 18,
    fontWeight: 500,
    border: "1px solid rgba(239,68,68,0.25)",
    cursor: "pointer",
    fontSize: 12,
    fontFamily: "var(--font)",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  input: {
    background: "var(--input-bg)",
    border: "1px solid var(--input-border)",
    borderRadius: 8,
    padding: "8px 12px",
    color: "var(--input-color)",
   fontSize: 12,
    fontFamily: "var(--font)",
    outline: "none",
    width: "20%",
    boxSizing: "border-box",
  },
  select: {
    background: "var(--input-bg)",
    border: "1px solid var(--input-border)",
    borderRadius: 8,
    padding: "8px 12px",
    color: "var(--input-color)",
   fontSize: 12,
    fontFamily: "var(--font)",
    outline: "none",
    cursor: "pointer",
  },
};

// ─── Status Chip ─────────────────────────────────────────────────────────────
const StatusChip = ({ status }) => {
  const map = {
    Ready:     { bg: "rgba(74,222,128,0.1)",  color: C.success, border: "rgba(74,222,128,0.25)"  },
    Pending:   { bg: "rgba(245,158,11,0.1)",  color: C.warning, border: "rgba(245,158,11,0.25)"  },
    Review:    { bg: "rgba(245,158,11,0.1)",  color: C.warning, border: "rgba(245,158,11,0.25)"  },
    Blocked:   { bg: "rgba(239,68,68,0.1)",   color: C.error,   border: "rgba(239,68,68,0.25)"   },
    Locked:    { bg: "rgba(134,96,248,0.1)",  color: C.accent,  border: "rgba(134,96,248,0.25)"  },
    Corrected: { bg: "rgba(59,130,246,0.1)",  color: "#3B82F6", border: "rgba(59,130,246,0.25)"  },
    Approved:  { bg: "rgba(59,130,246,0.1)",  color: "#3B82F6", border: "rgba(59,130,246,0.25)"  },
    Urgent:    { bg: "rgba(239,68,68,0.1)",   color: C.error,   border: "rgba(239,68,68,0.25)"   },
    High:      { bg: "rgba(239,68,68,0.08)",  color: C.error,   border: "rgba(239,68,68,0.2)"    },
    Medium:    { bg: "rgba(245,158,11,0.08)", color: C.warning, border: "rgba(245,158,11,0.2)"   },
    Low:       { bg: "rgba(74,222,128,0.08)", color: C.success, border: "rgba(74,222,128,0.2)"   },
  };
  const t = map[status] || map["Pending"];
  return (
    <span style={{
      background: t.bg, color: t.color,
      border: `1px solid ${t.border}`,
      padding: "4px 12px", borderRadius: 20,fontSize: 12, fontWeight: 600,
    }}>{status}</span>
  );
};

// ─── TAB ICONS ────────────────────────────────────────────────────────────────
const NAV_ICONS = {
  inputs: "fa-calendar-check",
  detail: "fa-magnifying-glass-chart",
  queue:  "fa-list-check",
};

// ─── Side Nav — hover expand / auto collapse ──────────────────────────────────
const Nav = ({ activeTab, setActiveTab }) => {
  const [expanded, setExpanded] = useState(false);

  const tabs = [
    { key: "inputs", label: "Attendance Inputs" },
    { key: "detail", label: "Detail Review"     },
    { key: "queue",  label: "Approval Queue"    },
  ];

  return (
    <aside
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
      style={{
        width:    expanded ? 220 : 56,
        minWidth: expanded ? 220 : 56,
        height: "100%",
        background: "var(--pay-surface)",
        borderRight: `1px solid var(--pay-border)`,
        display: "flex",
        flexDirection: "column",
        transition: "width 0.25s cubic-bezier(0.4,0,0.2,1), min-width 0.25s cubic-bezier(0.4,0,0.2,1)",
        overflow: "hidden",
        flexShrink: 0,
        zIndex: 50,
      }}
    >
      {/* ── Header ── */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "0 13px",
        height: 56,
        borderBottom: `1px solid var(--pay-border)`,
        flexShrink: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}>
        {/* Logo mark */}
        <div style={{
          width: 30, height: 30, borderRadius: 8,
          background: "linear-gradient(135deg, #8660F8 0%, #5b3fd4 100%)",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
          boxShadow: "0 0 10px rgba(134,96,248,0.4)",
        }}>
          <i className="fa-solid fa-calendar-check" style={{ color: "#fff",fontSize: 12 }} />
        </div>

        {/* Title — fades in on hover */}
        <div style={{
          opacity: expanded ? 1 : 0,
          transform: expanded ? "translateX(0)" : "translateX(-8px)",
          transition: "opacity 0.2s ease, transform 0.2s ease",
          pointerEvents: "none",
        }}>
          <div style={{fontSize: 12, fontWeight: 700, color: "var(--pay-text)", lineHeight: 1.2 }}>
            Attendance
          </div>
          <div style={{ fontSize: 10, color: "var(--pay-text-muted)", lineHeight: 1.2 }}>
            Input & Review
          </div>
        </div>
      </div>

      {/* ── Nav Items ── */}
      <nav1 style={{ padding: "10px 8px", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        {tabs.map(t => {
          const isActive = activeTab === t.key;
          const icon = NAV_ICONS[t.key];
          return (
            <div
              key={t.key}
              onClick={() => setActiveTab(t.key)}
              title={!expanded ? t.label : ""}
              style={{
                display: "flex", alignItems: "center", gap: 10,
                padding: "9px 10px", borderRadius: 10, cursor: "pointer",
                marginBottom: 3,
                background: isActive ? "rgba(134,96,248,0.15)" : "transparent",
                border: isActive ? "1px solid rgba(134,96,248,0.3)" : "1px solid transparent",
                transition: "all 0.15s ease",
                position: "relative", whiteSpace: "nowrap",
                userSelect: "none",
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = "rgba(134,96,248,0.07)";
                  e.currentTarget.style.border = "1px solid rgba(134,96,248,0.15)";
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.border = "1px solid transparent";
                }
              }}
            >
              {/* Active bar */}
              {isActive && (
                <div style={{
                  position: "absolute", left: 0, top: "18%", bottom: "18%",
                  width: 3, borderRadius: "0 3px 3px 0",
                  background: C.accent, boxShadow: "0 0 8px rgba(134,96,248,0.7)",
                }} />
              )}

              {/* Icon box */}
              <div style={{
                width: 30, height: 30, borderRadius: 8,
                background: isActive ? "rgba(134,96,248,0.22)" : "rgba(169,163,201,0.07)",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0, transition: "background 0.15s",
              }}>
                <i className={`fa-solid ${icon}`} style={{
                 fontSize: 12,
                  color: isActive ? C.accent : C.muted,
                  transition: "color 0.15s",
                }} />
              </div>

              {/* Label — slides in on expand */}
              <span style={{
               fontSize: 12,
                fontWeight: isActive ? 600 : 500,
                color: isActive ? "var(--pay-text)" : "var(--pay-text-muted)",
                opacity: expanded ? 1 : 0,
                transform: expanded ? "translateX(0)" : "translateX(-6px)",
                transition: "opacity 0.2s ease, transform 0.2s ease, color 0.15s",
                pointerEvents: "none",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}>
                {t.label}
              </span>
            </div>
          );
        })}
      </nav1>

      {/* ── Bottom badge ── */}
      <div style={{
        padding: "12px 8px",
        borderTop: `1px solid var(--pay-border)`,
        flexShrink: 0, overflow: "hidden",
      }}>
        <div style={{
          background: "rgba(134,96,248,0.1)",
          border: "1px solid rgba(134,96,248,0.22)",
          borderRadius: 8, padding: "8px 10px",
          display: "flex", alignItems: "center", gap: 8,
          whiteSpace: "nowrap",
        }}>
          <i className="fa-solid fa-calendar-days"
            style={{ color: C.accent,fontSize: 12, flexShrink: 0 }} />
          <span style={{
           fontSize: 12, fontWeight: 600, color: "var(--pay-text)",
            opacity: expanded ? 1 : 0,
            transform: expanded ? "translateX(0)" : "translateX(-6px)",
            transition: "opacity 0.2s ease, transform 0.2s ease",
            pointerEvents: "none",
          }}>
            {new Date().toLocaleString("default", { month: "short" })} {new Date().getFullYear()}
          </span>
        </div>
      </div>
    </aside>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// PAGE 1 — ATTENDANCE INPUTS
// ════════════════════════════════════════════════════════════════════════════
const procEmployees = [
  { name: "Sarah Jenkins", empId: "EMP-2401", dept: "Engineering", present: 23, lop: 1, ot: 16, payable: 23.5, source: "System",    sourceColor: C.accent,   status: "Ready",    updated: "2h ago",  avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg" },
  { name: "Marcus Chen",   empId: "EMP-1823", dept: "Sales",       present: 22, lop: 2, ot:  8, payable: 22,   source: "Manager",   sourceColor: "#C084FC",   status: "Review",   updated: "5h ago",  avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg" },
  { name: "Raj Kumar",     empId: "EMP-3102", dept: "Marketing",   present: 21, lop: 3, ot: 12, payable: 21.5, source: "Manual",    sourceColor: C.warning,   status: "Blocked",  updated: "1d ago",  avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg" },
  { name: "Emma Wilson",   empId: "EMP-2945", dept: "Operations",  present: 24, lop: 0, ot:  4, payable: 24,   source: "Manager",   sourceColor: "#C084FC",   status: "Approved", updated: "3h ago",  avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg" },
  { name: "David Park",    empId: "EMP-1567", dept: "Finance",     present: 22, lop: 1, ot:  6, payable: 22.5, source: "Corrected", sourceColor: C.warning,   status: "Ready",    updated: "6h ago",  avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-9.jpg" },
  { name: "Kavya Reddy",   empId: "EMP-2134", dept: "Finance",     present: 20, lop: 2, ot: 10, payable: 20.5, source: "System",    sourceColor: C.accent,    status: "Review",   updated: "8h ago",  avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-7.jpg" },
];

const KpiCard = ({ icon, iconColor, label, value, tag, tagColor, glow }) => (
  <div style={{ ...s.card, padding: 10, position: "relative", overflow: "hidden", boxShadow: glow ? `0 0 12px ${glow}` : s.card.boxShadow }}>
    <div style={{ position: "absolute", right: -15, top: -15, width: 60, height: 60, background: `${iconColor}18`, borderRadius: "50%", filter: "blur(15px)" }} />
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 4, color: C.muted, fontSize: 9, fontWeight: 500 }}>
        <i className={icon} style={{ color: iconColor, fontSize: 10 }} />{label}
      </div>
      <span style={{ fontSize: 8, fontWeight: 600, color: tagColor, background: `${tagColor}20`, padding: "2px 5px", borderRadius: 4 }}>{tag}</span>
    </div>
    <div style={{fontSize: 12, fontWeight: 700 }}>{value}</div>
  </div>
);

const ApprovalKpiCard = ({ icon, iconColor, borderColor, value, label, glow }) => {
  const [count, setCount] = useState(0);
  const [hovered, setHovered] = useState(false);
  const target = parseInt(value) || 0;
  useEffect(() => {
    let start = 0;
    const step = Math.ceil(target / (1200 / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); } else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [target]);
  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} style={{
      ...s.card, padding: 16, borderLeft: `3px solid ${borderColor}`,
      boxShadow: hovered ? `0 0 28px ${glow || borderColor + "55"}, 0 8px 32px rgba(0,0,0,0.3)` : glow ? `0 0 12px ${glow}` : s.card.boxShadow,
      transform: hovered ? "translateY(-4px) scale(1.02)" : "translateY(0) scale(1)",
      transition: "all 0.3s cubic-bezier(0.34,1.56,0.64,1)", cursor: "default", position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", inset: 0, background: `linear-gradient(135deg, ${borderColor}08 0%, transparent 60%)`, opacity: hovered ? 1 : 0, transition: "opacity 0.3s" }} />
      <div style={{ position: "relative", width: 36, height: 36, marginBottom: 10 }}>
        <div style={{ position: "absolute", inset: -4, borderRadius: "50%", border: `1px solid ${borderColor}`, opacity: hovered ? 0.6 : 0, transform: hovered ? "scale(1.3)" : "scale(1)", transition: "all 0.4s ease" }} />
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: hovered ? `${iconColor}30` : `${iconColor}18`, display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.3s" }}>
          <i className={`fa-solid ${icon}`} style={{ color: iconColor, fontSize: 12, transform: hovered ? "scale(1.15) rotate(-5deg)" : "scale(1) rotate(0deg)", transition: "transform 0.3s cubic-bezier(0.34,1.56,0.64,1)" }} />
        </div>
      </div>
      <div style={{ fontSize: 12, fontWeight: 700, color: iconColor, marginBottom: 2, letterSpacing: hovered ? "1px" : "0px", transition: "letter-spacing 0.3s" }}>{count}</div>
      <div style={{ fontSize: 12, color: C.muted }}>{label}</div>
      <div style={{ position: "absolute", bottom: 0, left: 0, height: 2, background: `linear-gradient(to right, ${borderColor}, transparent)`, width: hovered ? "100%" : "30%", transition: "width 0.4s ease" }} />
    </div>
  );
};

const PlotlyBarChart = () => {
  const ref = useRef(null);
  useEffect(() => {
    const load = () => {
      if (!window.Plotly || !ref.current) return;
      window.Plotly.newPlot(ref.current, [{ type: "bar", x: ["Engineering","Sales","Marketing","Product","HR","Finance","Design","Operations"], y: [23.5,22.8,21.2,22.1,22.9,22.5,23.1,23.4], marker: { color: "rgba(134,96,248,0.85)", line: { color: "rgba(134,96,248,1)", width: 1 } }, hovertemplate: "<b>%{x}</b><br>Avg Days: %{y}<extra></extra>" }], { paper_bgcolor: "transparent", plot_bgcolor: "transparent", font: { color: "#9B97B2", size: 10, family: "inherit" }, margin: { t: 10, r: 10, b: 40, l: 30 }, xaxis: { gridcolor: "rgba(169,163,201,0.08)", tickfont: { size: 9 }, fixedrange: true }, yaxis: { gridcolor: "rgba(169,163,201,0.08)", tickfont: { size: 9 }, fixedrange: true }, hoverlabel: { bgcolor: getComputedStyle(document.documentElement).getPropertyValue('--pay-surface').trim() || "#ffffff", bordercolor: "rgba(134,96,248,0.4)", font: { color: getComputedStyle(document.documentElement).getPropertyValue('--pay-text').trim() || "#111827", size: 11 } } }, { displayModeBar: false, responsive: true });
    };
    if (window.Plotly) load();
    else { const sc = document.createElement("script"); sc.src = "https://cdn.plot.ly/plotly-2.26.0.min.js"; sc.onload = load; document.head.appendChild(sc); }
    return () => { if (ref.current && window.Plotly) window.Plotly.purge(ref.current); };
  }, []);
  return <div ref={ref} style={{ height: 220 }} />;
};

const PlotlyLineChart = () => {
  const ref = useRef(null);
  useEffect(() => {
    const load = () => {
      if (!window.Plotly || !ref.current) return;
      window.Plotly.newPlot(ref.current, [
        { type: "scatter", mode: "lines+markers", name: "LOP Days", x: ["Jul","Aug","Sep","Oct"], y: [98,112,116,124], line: { color: "#EF4444", width: 2 }, marker: { color: "#EF4444", size: 6 }, hovertemplate: "%{x}: <b>%{y}</b><extra>LOP Days</extra>" },
        { type: "scatter", mode: "lines+markers", name: "OT Hours / 10", x: ["Jul","Aug","Sep","Oct"], y: [115,122,124,128], line: { color: "#F59E0B", width: 2 }, marker: { color: "#F59E0B", size: 6 }, hovertemplate: "%{x}: <b>%{y}</b><extra>OT Hours/10</extra>" },
      ], { paper_bgcolor: "transparent", plot_bgcolor: "transparent", font: { color: "#9B97B2", size: 10, family: "inherit" }, margin: { t: 10, r: 10, b: 40, l: 36 }, xaxis: { gridcolor: "rgba(169,163,201,0.08)", tickfont: { size: 9 }, fixedrange: true }, yaxis: { gridcolor: "rgba(169,163,201,0.08)", tickfont: { size: 9 }, fixedrange: true }, legend: { orientation: "h", x: 0, y: 1.15, font: { size: 10, color: "#9B97B2" }, bgcolor: "transparent" }, hoverlabel: { bgcolor: getComputedStyle(document.documentElement).getPropertyValue('--pay-surface').trim() || "#ffffff", bordercolor: "rgba(134,96,248,0.4)", font: { color: getComputedStyle(document.documentElement).getPropertyValue('--pay-text').trim() || "#111827", size: 11 } } }, { displayModeBar: false, responsive: true });
    };
    if (window.Plotly) load();
    else { const sc = document.createElement("script"); sc.src = "https://cdn.plot.ly/plotly-2.26.0.min.js"; sc.onload = load; document.head.appendChild(sc); }
    return () => { if (ref.current && window.Plotly) window.Plotly.purge(ref.current); };
  }, []);
  return <div ref={ref} style={{ height: 220 }} />;
};

const DrawerPanel = ({ open, onClose }) => (
  <>
    {open && <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", zIndex: 100 }} />}
    <div style={{ position: "fixed", right: 0, top: 0, bottom: 0, width: 560, background: C.surface, borderLeft: `1px solid ${C.border}`, zIndex: 101, overflowY: "auto", transform: open ? "translateX(0)" : "translateX(100%)", transition: "transform 0.3s ease" }}>
      <div style={{ position: "sticky", top: 0, background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 10 }}>
        <span style={{ fontWeight: 700,fontSize: 12 }}>Employee Attendance Details</span>
        <button onClick={onClose} style={{ ...s.elevated, width: 36, height: 36, borderRadius: "50%", color: C.muted, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><i className="fa-solid fa-xmark" /></button>
      </div>
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", gap: 16, paddingBottom: 20, borderBottom: `1px solid ${C.border}`, marginBottom: 20 }}>
          <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg" style={{ width: 72, height: 72, borderRadius: 12, objectFit: "cover", border: `2px solid rgba(134,96,248,0.3)` }} alt="" />
          <div>
            <div style={{ fontWeight: 700,fontSize: 12, marginBottom: 4 }}>Sarah Jenkins</div>
            <div style={{ color: C.muted,fontSize: 12, marginBottom: 8 }}>Senior Developer • ENG-042</div>
            <div style={{ display: "flex", gap: 8 }}>
              <StatusChip status="Ready" />
              <span style={{fontSize: 12, padding: "4px 10px", background: "rgba(134,96,248,0.1)", color: C.accent, border: `1px solid rgba(134,96,248,0.25)`, borderRadius: 20 }}>Engineering</span>
            </div>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
          {[["Present Days",23,C.success],["LOP Days",0,C.error],["OT Hours",16,C.warning],["Payable Days","23.5","#fff"]].map(([l,v,c]) => (
            <div key={l} style={{ ...s.elevated, padding: 16, borderRadius: 12 }}>
              <div style={{fontSize: 12, color: C.muted, marginBottom: 6 }}>{l}</div>
              <div style={{fontSize: 12, fontWeight: 700, color: c }}>{v}</div>
            </div>
          ))}
        </div>
        <div style={{ ...s.elevated, padding: 18, borderRadius: 12, marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa-solid fa-pen-to-square" style={{ color: C.accent }} /> Manual Adjustments
          </div>
          {["Additional LOP Days","Additional OT Hours"].map(label => (
            <div key={label} style={{ marginBottom: 12 }}>
              <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 4 }}>{label}</label>
              <input type="number" defaultValue="0" style={s.input} />
            </div>
          ))}
          <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 4 }}>Remarks</label>
          <textarea rows={3} placeholder="Add notes..." style={{ ...s.input, resize: "none" }} />
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button style={{ ...s.btnSecondary, flex: 1, justifyContent: "center" }}><i className="fa-solid fa-clock-rotate-left" /> View History</button>
          <button style={{ ...s.btnPrimary, flex: 1, justifyContent: "center" }}><i className="fa-solid fa-check" /> Save Changes</button>
        </div>
      </div>
    </div>
  </>
);

const AttendanceInputs = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const todayD = new Date();
  const [selectedMonth, setSelectedMonth] = useState(
    `${todayD.getFullYear()}-${String(todayD.getMonth() + 1).padStart(2, '0')}`
  );
  const kpis = [
    { icon: "fa-solid fa-calendar-check", iconColor: C.accent,   label: "Total Days",    value: 31,       tag: "0",      tagColor: C.muted    },
    { icon: "fa-solid fa-user-check",      iconColor: C.success,  label: "Present",       value: "19,842", tag: "94%",    tagColor: C.success  },
    { icon: "fa-solid fa-user-xmark",      iconColor: C.error,    label: "LOP Days",      value: 124,      tag: "+8",     tagColor: C.error    },
    { icon: "fa-solid fa-clock",           iconColor: C.warning,  label: "OT Hours",      value: "1,286",  tag: "+42",    tagColor: C.warning  },
    { icon: "fa-solid fa-calendar-days",   iconColor: "#22D3EE",  label: "Payable Days",  value: "25,894", tag: "Ready",  tagColor: C.success  },
    { icon: "fa-solid fa-triangle-exclamation", iconColor: C.error, label: "Pending",    value: 18,       tag: "Action", tagColor: C.error, glow: "rgba(239,68,68,0.2)" },
  ];
  return (
    <div style={{ maxWidth: 1500, margin: "0 auto", padding: "24px 20px", display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
            <h1 style={{fontSize: 12, fontWeight: 700, margin: 0, color: "var(--text-primary)" }}>Attendance Inputs</h1>
            <span style={{ padding: "3px 10px", borderRadius: 16, background: "rgba(206,203,212,0.15)", color: C.accent, border: `1px solid rgba(134,96,248,0.3)`, fontSize: 10 }}>October 2023</span>
          </div>
          <p style={{ color: "var(--text-muted)", margin: 0, fontSize: 12 }}>Verify payable days, LOP & OT before running payroll for 842 employees</p>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          <button style={{ ...s.btnGhost, padding: "6px 12px",fontSize: 12 }}><i className="fa-solid fa-file-import" style={{fontSize: 12 }} />Import Corrections</button>
          <button style={{ ...s.btnGhost, padding: "6px 12px",fontSize: 12 }}><i className="fa-solid fa-file-excel" style={{fontSize: 12 }} />Export Excel</button>
          <button style={{ ...s.btnSecondary, padding: "6px 14px",fontSize: 12 }}><i className="fa-solid fa-calculator" style={{fontSize: 12 }} />Recalculate</button>
          <button style={{ ...s.btnSecondary, padding: "6px 14px",fontSize: 12 }}><i className="fa-solid fa-wand-magic-sparkles" style={{fontSize: 12 }} />Auto Resolve</button>
          <button style={{ ...s.btnPrimary, padding: "8px 18px", fontSize: 12, animation: "pulse-glow 2s ease-in-out infinite" }}><i className="fa-solid fa-arrow-right" style={{fontSize: 12 }} />Send to Payroll</button>
        </div>
      </div>
      <div className="filter-controls" style={{ background: "var(--pay-surface)", border: "1px solid var(--pay-border)", borderRadius: 12, padding: "8px 12px", marginBottom: 0, flexWrap: "nowrap", overflowX: "auto", display: "flex", alignItems: "center", gap: 8 }}>

          {/* Month */}
          <div style={{ flex: "0 0 auto", minWidth: 0 }}>
            <MonthPicker
              value={selectedMonth}
              onChange={(val) => setSelectedMonth(val)}
            />
          </div>

          {/* Branch */}
          <div className="field-wrap" style={{ flex: "0 0 130px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Branches</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>

          {/* Department */}
          <div className="field-wrap" style={{ flex: "0 0 145px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Departments</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>

          {/* Shift */}
          <div className="field-wrap" style={{ flex: "0 0 120px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Shifts</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>

          {/* Type */}
          <div className="field-wrap" style={{ flex: "0 0 115px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Types</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>

          {/* Search */}
          <div className="field-wrap search-input-wrapper" style={{ flex: "1 1 180px", minWidth: 0 }}>
            <span className="fi-left">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </span>
            <input className="filter-select" placeholder="Search by Employee ID or Name" style={{ width: "100%", fontSize: 11, padding: "6px 12px 6px 26px", cursor: "text" }} />
          </div>

      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 10 }}>
        {kpis.map(k => <KpiCard key={k.label} {...k} />)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
        <ApprovalKpiCard icon="fa-circle-exclamation" iconColor={C.error}   borderColor={C.error}   value={23}  label="Needs Immediate Action" />
        <ApprovalKpiCard icon="fa-clock"              iconColor={C.warning} borderColor={C.warning} value={127} label="Total Pending Cases" />
        <ApprovalKpiCard icon="fa-check-double"       iconColor={C.success} borderColor={C.success} value={342} label="Approved This Month" glow="rgba(74,222,128,0.2)" />
      </div>
      <div style={{ ...s.card, padding: 16, borderLeft: `4px solid ${C.error}`, boxShadow: "0 0 16px rgba(239,68,68,0.15)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <div style={{ fontWeight: 600,fontSize: 12 }}>Exception Center</div>
              <span style={{ width: 22, height: 22, borderRadius: "50%", background: "rgba(239,68,68,0.2)", color: C.error, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700 }}>18</span>
            </div>
            <div style={{ color: C.muted, fontSize: 10 }}>Attendance anomalies blocking payroll - immediate action required</div>
          </div>
          <button style={{ ...s.btnGhost, padding: "4px 10px", fontSize: 10 }}>Resolve All</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
          {[["fa-user-clock",C.error,"Missing Punch Records","8 employees"],["fa-clock-rotate-left",C.warning,"Excess OT Hours","6 employees"],["fa-ban",C.error,"Unapproved Absences","4 employees"]].map(([icon,color,title,sub]) => (
            <div key={title} style={{ ...s.elevated, padding: 12, borderLeft: `2px solid ${color}`, borderRadius: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: `${color}18`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <i className={`fa-solid ${icon}`} style={{ color,fontSize: 12 }} />
                </div>
                <div>
                  <div style={{ fontWeight: 600,fontSize: 12 }}>{title}</div>
                  <div style={{ fontSize: 9, color: C.muted }}>{sub}</div>
                </div>
              </div>
              <button style={{ ...s.btnSecondary, width: "100%", justifyContent: "center", padding: "5px 10px", fontSize: 10 }}>Review & Fix</button>
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div style={{ ...s.card, padding: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div><div style={{ fontWeight: 600,fontSize: 12 }}>Department-wise Payable Days</div><div style={{ color: C.muted, fontSize: 10, marginTop: 2 }}>Average payable days by department</div></div>
            <button style={{ ...s.btnGhost, padding: "4px 10px", fontSize: 10 }}>View Details</button>
          </div>
          <PlotlyBarChart />
        </div>
        <div style={{ ...s.card, padding: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div><div style={{ fontWeight: 600,fontSize: 12 }}>LOP & OT Trends</div><div style={{ color: C.muted, fontSize: 10, marginTop: 2 }}>Monthly comparison of LOP days and OT hours</div></div>
            <button style={{ ...s.btnGhost, padding: "4px 10px", fontSize: 10 }}>Export Data</button>
          </div>
          <PlotlyLineChart />
        </div>
      </div>
      <div style={{ ...s.card, padding: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
          <div><div style={{ fontWeight: 600,fontSize: 12 }}>Bulk Import Corrections</div><div style={{ color: C.muted, fontSize: 10, marginTop: 2 }}>Upload attendance corrections via CSV or Excel file</div></div>
          <button style={{ ...s.btnGhost, padding: "4px 10px", fontSize: 10 }}><i className="fa-solid fa-download" style={{ fontSize: 10 }} />Download Template</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          {[["fa-file-csv",C.accent,"Upload CSV File"],["fa-file-excel",C.success,"Upload Excel File"]].map(([icon,color,label]) => (
            <div key={label} style={{ ...s.elevated, padding: 16, borderRadius: 12, border: `2px dashed rgba(169,163,201,0.2)`, textAlign: "center", cursor: "pointer" }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: `${color}18`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>
                <i className={`fa-solid ${icon}`} style={{ color,fontSize: 12 }} />
              </div>
              <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 4 }}>{label}</div>
              <div style={{ fontSize: 10, color: C.muted, marginBottom: 10 }}>Drag and drop or click to browse</div>
              <button style={{ ...s.btnSecondary, fontSize: 10, padding: "5px 14px", margin: "0 auto" }}>Choose File</button>
            </div>
          ))}
        </div>
        <div style={{ ...s.elevated, padding: 10, borderRadius: 8, display: "flex", alignItems: "center", gap: 8 }}>
          <i className="fa-solid fa-circle-info" style={{ color: C.accent, fontSize: 12 }} />
          <span style={{ fontSize: 10, color: C.muted }}>File must contain columns: Employee ID, Date, LOP Days, OT Hours, Remarks. Maximum 5000 rows per upload.</span>
        </div>
      </div>
      <div style={{ ...s.card, padding: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div><div style={{ fontWeight: 600,fontSize: 12 }}>Attendance Health Check</div><div style={{ color: C.muted, fontSize: 10, marginTop: 2 }}>Validation status before payroll processing</div></div>
          <span style={{ color: C.success, fontSize: 10, fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}><i className="fa-solid fa-check-circle" style={{ fontSize: 10 }} />4 of 5 Complete</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10 }}>
          {[{label:"Data Locked",sub:"Attendance frozen",ok:true},{label:"Shifts Assigned",sub:"All mapped",ok:true},{label:"Leave Applied",sub:"Approved leaves",ok:true},{label:"OT Approved",sub:"Manager verified",ok:true},{label:"Exceptions",sub:"18 pending",ok:false}].map(item => (
            <div key={item.label} style={{ ...s.elevated, padding: 10, borderLeft: `3px solid ${item.ok ? C.success : C.warning}`, boxShadow: item.ok ? "none" : `0 0 10px rgba(245,158,11,0.15)` }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <div style={{ width: 28, height: 28, borderRadius: "50%", background: item.ok ? "rgba(74,222,128,0.1)" : "rgba(245,158,11,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={item.ok ? "fa-solid fa-check" : "fa-solid fa-clock"} style={{ color: item.ok ? C.success : C.warning, fontSize: 12 }} />
                </div>
                <span style={{ fontSize: 9, padding: "2px 8px", borderRadius: 12, background: item.ok ? "rgba(74,222,128,0.1)" : "rgba(245,158,11,0.1)", color: item.ok ? C.success : C.warning, border: `1px solid ${item.ok ? "rgba(74,222,128,0.2)" : "rgba(245,158,11,0.2)"}` }}>{item.ok ? "Ready" : "Pending"}</span>
              </div>
              <div style={{ fontWeight: 600,fontSize: 12 }}>{item.label}</div>
              <div style={{ fontSize: 9, color: C.muted, marginTop: 2 }}>{item.sub}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ ...s.card, padding: 14, borderLeft: `3px solid ${C.accent}`, boxShadow: "0 0 16px rgba(134,96,248,0.2)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(134,96,248,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <i className="fa-solid fa-clipboard-check" style={{ color: C.accent,fontSize: 12 }} />
            </div>
            <div>
              <div style={{ fontWeight: 700,fontSize: 12, marginBottom: 2 }}>824 of 842 Ready for Payroll</div>
              <div style={{ fontSize: 10, color: C.muted }}>18 employees pending review · Total Payable: 25,894 days</div>
              <div style={{ display: "flex", gap: 12, marginTop: 4, fontSize: 10 }}>
                <span style={{ color: C.success }}><i className="fa-solid fa-check-circle" style={{ fontSize: 9 }} /> 824 Approved</span>
                <span style={{ color: C.warning }}><i className="fa-solid fa-clock" style={{ fontSize: 9 }} /> 18 Pending</span>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={{ ...s.btnSecondary, padding: "5px 12px", fontSize: 10 }}><i className="fa-solid fa-triangle-exclamation" style={{ fontSize: 9 }} />Resolve Pending</button>
            <button style={{ ...s.btnPrimary, padding: "6px 16px",fontSize: 12 }}><i className="fa-solid fa-arrow-right" style={{ fontSize: 10 }} />Send to Run Payroll</button>
          </div>
        </div>
      </div>
      <div style={{ ...s.card, overflow: "hidden" }}>
        <div style={{ padding: "12px 16px", borderBottom: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 12 }}>Employee Attendance Inputs</div>
            <div style={{ color: C.muted, fontSize: 10, marginTop: 2 }}>Payable days calculation with LOP and overtime adjustments</div>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            {["Lock Attendance","Bulk Approve","Export"].map(l => <button key={l} style={{ ...s.btnGhost, padding: "4px 10px", fontSize: 10 }}>{l}</button>)}
          </div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: C.elevated }}>
                {["","Employee","Dept","Present","LOP","OT Hrs","Payable","Source","Status","Updated","Actions"].map(h => (
                  <th key={h} style={{ padding: "8px 12px", textAlign: h === "Actions" ? "right" : "left", fontSize: 9, fontWeight: 600, color: C.muted, borderBottom: `1px solid ${C.border}`, whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {procEmployees.map((emp, i) => (
                <tr key={i} onClick={() => setDrawerOpen(true)} style={{ cursor: "pointer", transition: "background 0.15s", borderBottom: `1px solid rgba(169,163,201,0.05)` }} onMouseEnter={e => e.currentTarget.style.background = "rgba(134,96,248,0.05)"} onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <td style={{ padding: "8px 12px" }}><input type="checkbox" onClick={e => e.stopPropagation()} style={{ accentColor: C.accent, width: 12, height: 12 }} /></td>
                  <td style={{ padding: "8px 12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <img src={emp.avatar} style={{ width: 28, height: 28, borderRadius: "50%", objectFit: "cover", border: `1px solid rgba(134,96,248,0.2)` }} alt="" />
                      <div><div style={{ fontWeight: 600,fontSize: 12 }}>{emp.name}</div><div style={{ fontSize: 9, color: C.muted }}>{emp.empId}</div></div>
                    </div>
                  </td>
                  <td style={{ padding: "8px 12px", fontSize: 10 }}>{emp.dept}</td>
                  <td style={{ padding: "8px 12px", fontWeight: 600, color: C.success,fontSize: 12 }}>{emp.present}</td>
                  <td style={{ padding: "8px 12px", fontWeight: 600, color: C.error,fontSize: 12 }}>{emp.lop}</td>
                  <td style={{ padding: "8px 12px", fontWeight: 600, color: "#60A5FA",fontSize: 12 }}>{emp.ot}</td>
                  <td style={{ padding: "8px 12px", fontWeight: 700,fontSize: 12 }}>{emp.payable}</td>
                  <td style={{ padding: "8px 12px" }}><span style={{ fontSize: 9, padding: "2px 6px", borderRadius: 12, background: `${emp.sourceColor}18`, color: emp.sourceColor, border: `1px solid ${emp.sourceColor}40` }}>{emp.source}</span></td>
                  <td style={{ padding: "8px 12px" }}><StatusChip status={emp.status} /></td>
                  <td style={{ padding: "8px 12px", fontSize: 9, color: C.muted }}>{emp.updated}</td>
                  <td style={{ padding: "8px 12px", textAlign: "right" }}>
                    <div style={{ display: "flex", gap: 4, justifyContent: "flex-end" }}>
                      {["eye","pen-to-square","clock-rotate-left"].map(icon => (
                        <button key={icon} onClick={e => { e.stopPropagation(); if (icon === "eye") setDrawerOpen(true); }} style={{ width: 24, height: 24, borderRadius: "50%", background: C.elevated, border: "none", color: C.muted, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <i className={`fa-solid fa-${icon}`} style={{ fontSize: 9 }} />
                        </button>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ padding: "8px 16px", borderTop: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 10, color: C.muted }}>Showing 1–6 of 842 employees</span>
          <div style={{ display: "flex", gap: 4 }}>
            {["‹","1","2","3","...","141","›"].map((p, i) => (
              <button key={i} style={{ width: 24, height: 24, borderRadius: 4, fontSize: 10, fontWeight: 600, cursor: "pointer", background: p === "1" ? C.accent : C.elevated, color: p === "1" ? "#fff" : C.muted, border: "none" }}>{p}</button>
            ))}
          </div>
        </div>
      </div>
      <DrawerPanel open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <style>{`@keyframes pulse-glow { 0%,100% { box-shadow: 0 0 10px rgba(134,96,248,0.3); } 50% { box-shadow: 0 0 18px rgba(134,96,248,0.5); } }`}</style>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// PAGE 2 — DETAIL REVIEW  (unchanged — all original code preserved)
// ════════════════════════════════════════════════════════════════════════════
const dayData = [
  { d: "01", type: "present" }, { d: "02", type: "present" }, { d: "03", type: "late"    },
  { d: "04", type: "holiday" }, { d: "05", type: "weekoff" }, { d: "06", type: "weekoff" },
  { d: "07", type: "present" }, { d: "08", type: "missing" }, { d: "09", type: "present" },
  { d: "10", type: "leave"   }, { d: "11", type: "weekoff" }, { d: "12", type: "weekoff" },
  { d: "14", type: "present" }, { d: "15", type: "present" }, { d: "16", type: "present" },
  { d: "17", type: "present" }, { d: "18", type: "late"    }, { d: "19", type: "weekoff" },
  { d: "20", type: "weekoff" }, { d: "21", type: "present" }, { d: "22", type: "present" },
  { d: "23", type: "lop"     }, { d: "24", type: "present" }, { d: "25", type: "present" },
  { d: "26", type: "weekoff" }, { d: "27", type: "weekoff" }, { d: "28", type: "present" },
  { d: "29", type: "present" }, { d: "30", type: "present" },
];
const dayColors = {
  present: { bg: "rgba(74,222,128,0.15)",  color: C.success, border: "rgba(74,222,128,0.3)"  },
  absent:  { bg: "rgba(239,68,68,0.15)",   color: C.error,   border: "rgba(239,68,68,0.3)"   },
  weekoff: { bg: "rgba(169,163,201,0.1)",  color: C.muted,   border: "rgba(169,163,201,0.2)" },
  holiday: { bg: "rgba(59,130,246,0.15)",  color: "#3B82F6", border: "rgba(59,130,246,0.3)"  },
  leave:   { bg: "rgba(168,85,247,0.15)",  color: "#A855F7", border: "rgba(168,85,247,0.3)"  },
  lop:     { bg: "rgba(245,158,11,0.15)",  color: C.warning, border: "rgba(245,158,11,0.3)"  },
  missing: { bg: "transparent",            color: C.error,   border: C.error, dashed: true   },
  late:    { bg: "rgba(245,158,11,0.1)",   color: C.warning, border: "rgba(245,158,11,0.25)" },
  half:    { bg: "rgba(168,85,247,0.1)",   color: "#A855F7", border: "rgba(168,85,247,0.25)" },
};

const DetailReview = () => {
  const [selectedDay, setSelectedDay] = useState("08");
  return (
    <div style={{ maxWidth: 1500, margin: "0 auto", padding: "24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <h2 style={{ margin: 0, fontSize: 12, fontWeight: 700 }}>Attendance Detail Review</h2>
              <StatusChip status="Pending" />
            </div>
            <div style={{ color: C.muted, fontSize: 12 }}>Verify employee attendance, payable days, punches & exceptions</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button style={s.btnGhost}>Hold</button>
          <button style={s.btnSecondary}><i className="fa-solid fa-chevron-right" />Next Employee</button>
          <button style={s.btnPrimary}><i className="fa-solid fa-check" />Approve Attendance</button>
        </div>
      </div>
      <div style={{ ...s.card, padding: 20, marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg" style={{ width: 72, height: 72, borderRadius: 12, objectFit: "cover", border: "2px solid rgba(134,96,248,0.3)" }} alt="" />
            <div>
              <div style={{ fontWeight: 700,fontSize: 12, marginBottom: 4 }}>Arun Kumar</div>
              <div style={{ display: "flex", gap: 20, color: C.muted, fontSize: 12, flexWrap: "wrap" }}>
                {[["fa-id-badge","EMP-2401",C.accent],["fa-briefcase","Engineer",null],["fa-location-dot","Bangalore",null],["fa-clock","General Shift",null]].map(([icon,text,color]) => (
                  <span key={text} style={{ display: "flex", alignItems: "center", gap: 5 }}><i className={`fa-solid ${icon}`} style={{ color: color || C.muted }} />{text}</span>
                ))}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            {[["Present",23,C.success],["LOP",1,C.error],["OT","8h",C.accent],["Payable",29,"#fff"]].map(([l,v,c]) => (
              <div key={l} style={{ ...s.elevated, padding: "10px 18px", textAlign: "center", borderLeft: `2px solid ${c}` }}>
                <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>{l}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: c }}>{v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "260px 1fr 260px", gap: 20 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ ...s.card, padding: 16 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-user" style={{ color: C.accent }} />Employee Info</div>
            {[["Department","Engineering"],["Reporting To","Sarah M."],["Work Days","Mon - Fri"],["Shift Timing","09:00 - 18:00"],["Location","Bangalore HQ"]].map(([k,v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", marginBottom: 10, fontSize: 12 }}>
                <span style={{ color: C.muted }}>{k}</span><span style={{ fontWeight: 500 }}>{v}</span>
              </div>
            ))}
          </div>
          <div style={{ ...s.card, padding: 16 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-triangle-exclamation" style={{ color: C.warning }} />Issue Summary</div>
            {[["fa-circle-exclamation",C.error,"Missing Punches",2],["fa-clock",C.warning,"Late Marks",3],["fa-calendar-minus","#60A5FA","Half Days",1],["fa-file-pen","#C084FC","Pending Requests",1]].map(([icon,color,label,count]) => (
              <div key={label} style={{ ...s.elevated, padding: 10, borderRadius: 8, marginBottom: 8, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 6, background: `${color}18`, display: "flex", alignItems: "center", justifyContent: "center" }}><i className={`fa-solid ${icon}`} style={{ color,fontSize: 12 }} /></div>
                  <span style={{ fontSize: 12, fontWeight: 500 }}>{label}</span>
                </div>
                <span style={{ fontWeight: 700, color,fontSize: 12 }}>{count}</span>
              </div>
            ))}
            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
              <button style={{ ...s.btnGhost, flex: 1, justifyContent: "center",fontSize: 12 }}>Open Requests</button>
              <button style={{ ...s.btnSuccess, flex: 1, justifyContent: "center",fontSize: 12 }}>Resolve</button>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ ...s.card, padding: "10px 12px", maxWidth: 340 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, flexWrap: "wrap", gap: 4 }}>
              <div style={{ fontWeight: 600, fontSize: 10 }}>Monthly Calendar — April 2026</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[["present","Present"],["absent","Absent"],["lop","LOP"],["missing","Missing"]].map(([type,label]) => {
                  const dc = dayColors[type];
                  return <span key={label} style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 8, color: C.muted }}><span style={{ width: 6, height: 6, borderRadius: 1, background: dc.bg, border: `1px ${dc.dashed?"dashed":"solid"} ${dc.border}`, flexShrink: 0 }} />{label}</span>;
                })}
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2, marginBottom: 2 }}>
              {["M","T","W","T","F","S","S"].map((d, i) => <div key={i} style={{ textAlign: "center", fontSize: 7, fontWeight: 600, color: C.muted }}>{d}</div>)}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
              {dayData.map(({ d, type }) => {
                const dc = dayColors[type] || dayColors.present;
                const isSel = d === selectedDay;
                return (
                  <div key={d} onClick={() => setSelectedDay(d)} style={{ height: 18, borderRadius: 3, background: dc.bg, cursor: "pointer", border: `${dc.dashed ? "1.5px dashed" : "1px solid"} ${isSel ? C.accent : dc.border}`, boxShadow: isSel ? `0 0 0 1.5px rgba(134,96,248,0.4)` : "none", transition: "all 0.1s", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ fontSize: 7, fontWeight: isSel ? 700 : 500, color: isSel ? C.accent : dc.color, lineHeight: 1 }}>{d}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ ...s.card, padding: 20 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-calendar-day" style={{ color: C.accent }} />Selected Day Details</div>
            <div style={{ ...s.elevated, padding: 16, borderRadius: 10, marginBottom: 14, borderLeft: `4px solid ${C.error}` }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
                <span style={{ fontWeight: 700,fontSize: 12 }}>08 April 2026 - Tuesday</span>
                <div style={{ display: "flex", gap: 8 }}>
                  <span style={{fontSize: 12, padding: "4px 10px", borderRadius: 20, background: "rgba(239,68,68,0.1)", color: C.error, border: `1px solid rgba(239,68,68,0.3)`, fontWeight: 600 }}>Missing Punch</span>
                  <span style={{fontSize: 12, padding: "4px 10px", borderRadius: 20, background: "rgba(245,158,11,0.1)", color: C.warning, border: `1px solid rgba(245,158,11,0.3)`, fontWeight: 600 }}>HR Corrected</span>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12, fontSize: 12 }}>
                {[["Clock In","09:18 AM",C.success],["Clock Out","06:40 PM",C.warning],["Worked Hours","8h 12m","#fff"],["Late By","18 minutes",C.warning]].map(([l,v,c]) => (
                  <div key={l}><div style={{ color: C.muted, marginBottom: 3 }}>{l}</div><div style={{ fontWeight: 600, color: c }}>{v}</div></div>
                ))}
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button style={s.btnSuccess}><i className="fa-solid fa-check" />Approve Correction</button>
              <button style={s.btnSecondary}><i className="fa-solid fa-circle-check" />Mark Present</button>
              <button style={s.btnGhost}><i className="fa-solid fa-calendar-minus" />Half Day</button>
              <button style={s.btnDanger}><i className="fa-solid fa-ban" />Mark LOP</button>
            </div>
          </div>
          <div style={{ ...s.card, padding: 20 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-calculator" style={{ color: C.accent }} />Payable Days Formula</div>
            {[["Total Days in Month","31","#fff"],["Weekly Offs","- 4",C.muted],["Holidays","- 1",C.muted],["Paid Leave","- 2",C.muted],["LOP Days","- 1",C.error],["OT Adjustment","+ 0",C.success]].map(([l,v,c]) => (
              <div key={l} style={{ ...s.elevated, padding: "10px 14px", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center", borderLeft: l === "LOP Days" ? `3px solid ${C.error}` : "none" }}>
                <span style={{fontSize: 12, color: C.muted }}>{l}</span><span style={{ fontWeight: 700, color: c }}>{v}</span>
              </div>
            ))}
            <div style={{ ...s.elevated, padding: "14px", marginTop: 4, display: "flex", justifyContent: "space-between", alignItems: "center", borderLeft: `4px solid ${C.accent}`, boxShadow: `0 0 16px rgba(134,96,248,0.25)` }}>
              <span style={{ fontWeight: 600 }}>Payable Days</span>
              <span style={{ fontWeight: 700, fontSize: 22, color: C.accent }}>29</span>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ ...s.card, padding: 16 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-file-pen" style={{ color: C.accent }} />Regularization Requests</div>
            <div style={{ ...s.elevated, padding: 12, borderLeft: `2px solid ${C.warning}`, borderRadius: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6, fontSize: 12 }}>
                <span style={{ fontWeight: 600 }}>08 Apr - Forgot Checkout</span><StatusChip status="Pending" />
              </div>
              <div style={{fontSize: 12, color: C.muted, marginBottom: 6 }}>Requested Out: 06:40 PM</div>
              <div style={{fontSize: 12, color: C.muted, marginBottom: 10 }}>"Was in meeting, forgot to punch out"</div>
              <div style={{ display: "flex", gap: 6 }}>
                <button style={{ ...s.btnSuccess, flex: 1, justifyContent: "center",fontSize: 12, padding: "6px" }}><i className="fa-solid fa-check" />Approve</button>
                <button style={{ ...s.btnDanger,  flex: 1, justifyContent: "center",fontSize: 12, padding: "6px" }}><i className="fa-solid fa-xmark" />Reject</button>
              </div>
            </div>
          </div>
          <div style={{ ...s.card, padding: 16 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-pen-to-square" style={{ color: C.accent }} />Manual Adjustments</div>
            {[["OT Hours","8.0"],["LOP Days","1"],["Payable Override","29"]].map(([l,v]) => (
              <div key={l} style={{ marginBottom: 12 }}>
                <label style={{fontSize: 12, color: C.muted, display: "block", marginBottom: 4 }}>{l}</label>
                <input defaultValue={v} style={s.input} />
              </div>
            ))}
            <button style={{ ...s.btnPrimary, width: "100%", justifyContent: "center", marginTop: 4 }}><i className="fa-solid fa-floppy-disk" />Save Adjustments</button>
          </div>
          <div style={{ ...s.card, padding: 16 }}>
            <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-clock-rotate-left" style={{ color: C.muted }} />Audit Trail</div>
            {[["HR corrected Apr 08 punch","By Admin • 2 hours ago"],["Manager approved leave","By Sarah M. • 3 days ago"],["OT added for Apr 18","By System • 5 days ago"]].map(([a,b]) => (
              <div key={a} style={{ ...s.elevated, padding: 10, borderRadius: 8, marginBottom: 8 }}>
                <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 2 }}>{a}</div>
                <div style={{fontSize: 12, color: C.muted }}>{b}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "rgba(15,11,36,0.97)", backdropFilter: "blur(12px)", borderTop: `1px solid ${C.border}`, padding: "14px 24px", zIndex: 50 }}>
        <div style={{ maxWidth: 1500, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(134,96,248,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}><i className="fa-solid fa-calendar-check" style={{ color: C.accent,fontSize: 12 }} /></div>
              <div>
                <div style={{ fontWeight: 700,fontSize: 12 }}>29 Payable Days</div>
                <div style={{fontSize: 12, color: C.muted }}>Review Pending · Arun Kumar (EMP-2401)</div>
              </div>
            </div>
            <div style={{ display: "flex", gap: 16,fontSize: 12 }}>
              <span style={{ color: C.error }}><i className="fa-solid fa-circle-exclamation" /> 2 Issues</span>
              <span style={{ color: C.warning }}><i className="fa-solid fa-file-pen" /> 1 Request</span>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button style={s.btnSecondary}><i className="fa-solid fa-floppy-disk" />Save Changes</button>
            <button style={s.btnPrimary}><i className="fa-solid fa-check-double" />Approve Attendance</button>
            <button style={s.btnSecondary}><i className="fa-solid fa-chevron-right" />Next Employee</button>
          </div>
        </div>
      </div>
      <div style={{ height: 70 }} />
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// PAGE 3 — APPROVAL QUEUE  (unchanged)
// ════════════════════════════════════════════════════════════════════════════
const queueData = [
  { name: "Arun Kumar",   empId: "EMP-2401", dept: "Engineering", issue: "Missing Punch Out",         detail: "In: 09:18 · Out: Missing",          date: "08 Apr 2026", day: "Tuesday",  source: "HR Corrected",   srcColor: C.warning, priority: "Urgent", status: "Pending", by: "Employee", ago: "2 hours ago", avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg" },
  { name: "Priya Sharma", empId: "EMP-1823", dept: "Sales",       issue: "Late Mark - 45 mins",       detail: "In: 09:45 · Out: 18:30",            date: "09 Apr 2026", day: "Wednesday",source: "Face Punch",      srcColor: C.success, priority: "High",   status: "Pending", by: "Manager",  ago: "1 day ago",   avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg" },
  { name: "Rahul Verma",  empId: "EMP-3102", dept: "Marketing",   issue: "Geo Fence Mismatch",        detail: "Punched 2.3km away from office",    date: "10 Apr 2026", day: "Thursday", source: "Mobile Punch",   srcColor: "#60A5FA", priority: "Medium", status: "Pending", by: "Employee", ago: "3 hours ago", avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg" },
  { name: "Sneha Patel",  empId: "EMP-2945", dept: "Engineering", issue: "Regularization Request",    detail: "Half day leave request",            date: "11 Apr 2026", day: "Friday",   source: "Manager Marked", srcColor: "#C084FC", priority: "Medium", status: "Pending", by: "Employee", ago: "5 hours ago", avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg" },
  { name: "Amit Singh",   empId: "EMP-1567", dept: "Operations",  issue: "Shift Mismatch",            detail: "Punched during night shift hours",  date: "12 Apr 2026", day: "Saturday", source: "Imported",       srcColor: "#22D3EE", priority: "Low",    status: "Pending", by: "HR",       ago: "1 day ago",   avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-9.jpg" },
  { name: "Kavya Reddy",  empId: "EMP-2134", dept: "Finance",     issue: "Multiple Missing Punches",  detail: "3 days without complete records",   date: "08-10 Apr",   day: "Multiple", source: "Auto Marked",    srcColor: C.muted,   priority: "Urgent", status: "Pending", by: "Employee", ago: "4 hours ago", avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-7.jpg" },
];

const ApprovalQueue = () => {
  const [selected, setSelected] = useState([]);
  const todayAQ = new Date();
  const [approvalMonth, setApprovalMonth] = useState(
    `${todayAQ.getFullYear()}-${String(todayAQ.getMonth() + 1).padStart(2, '0')}`
  );
  const toggleRow = (idx) => setSelected(p => p.includes(idx) ? p.filter(i => i !== idx) : [...p, idx]);
  const toggleAll = () => setSelected(selected.length === queueData.length ? [] : queueData.map((_, i) => i));
  return (
    <div style={{ maxWidth: 1500, margin: "0 auto", padding: "24px 24px 120px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 14 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
            <h2 style={{ margin: 0,fontSize: 12, fontWeight: 700 }}>Attendance Approval Queue</h2>
            <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 14px", borderRadius: 20, background: "rgba(239,68,68,0.1)", border: `1px solid rgba(239,68,68,0.3)` }}>
              <span style={{ width: 8, height: 8, background: C.error, borderRadius: "50%", animation: "pulse 2s infinite" }} />
              <span style={{ color: C.error, fontWeight: 600,fontSize: 12 }}>127 Pending</span>
            </div>
          </div>
          <p style={{ margin: 0, color: C.muted, fontSize: 12 }}>Review and approve all attendance cases before running payroll · April 2026</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button style={s.btnGhost}><i className="fa-solid fa-file-export" />Export Queue</button>
          <button style={s.btnGhost}><i className="fa-solid fa-rotate" />Refresh</button>
          <button style={{ ...s.btnPrimary, boxShadow: "0 0 18px rgba(134,96,248,0.35)" }}><i className="fa-solid fa-check-double" />Bulk Approve</button>
        </div>
      </div>
      <div style={{ ...s.card, padding: 12, marginBottom: 16 }}>
        {/* Filter row */}
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, marginBottom: 12 }}>
          {/* Month picker */}
          <MonthPicker
            value={approvalMonth}
            onChange={(val) => setApprovalMonth(val)}
          />
          {/* Branch */}
          <div className="field-wrap" style={{ flex: "0 0 130px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Branches</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
          {/* Department */}
          <div className="field-wrap" style={{ flex: "0 0 145px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Departments</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
          {/* Shift */}
          <div className="field-wrap" style={{ flex: "0 0 120px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Shifts</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
          {/* Issue Type */}
          <div className="field-wrap" style={{ flex: "0 0 120px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Issues</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
          {/* Priority */}
          <div className="field-wrap" style={{ flex: "0 0 115px", minWidth: 0 }}>
            <select className="filter-select" style={{ width: "100%", fontSize: 11, padding: "6px 24px 6px 10px" }}>
              <option>All Priority</option>
            </select>
            <span className="fi-right">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
        </div>
        {/* Search + toggles row */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
          <div className="field-wrap search-input-wrapper" style={{ flex: "1 1 260px", minWidth: 0 }}>
            <span className="fi-left">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </span>
            <input className="filter-select" placeholder="Search employee, ID, issue..." style={{ width: "100%", fontSize: 11, padding: "6px 12px 6px 26px", cursor: "text" }} />
          </div>
          <div style={{ display: "flex", gap: 16 }}>
            {["Only Urgent","Only Today"].map(l => (
              <label key={l} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 11, color: C.muted }}>
                <input type="checkbox" style={{ accentColor: C.accent }} />{l}
              </label>
            ))}
          </div>
        </div>
      </div>
      <div style={{ ...s.card, marginBottom: 16 }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: C.elevated }}>
                <th style={{ padding: "12px 16px", width: 44 }}><input type="checkbox" onChange={toggleAll} checked={selected.length === queueData.length} style={{ accentColor: C.accent }} /></th>
                {["Employee","Issue Details","Date","Source","Priority","Status","Requested By","Actions"].map(h => (
                  <th key={h} style={{ padding: "12px 16px", textAlign: h === "Actions" ? "right" : "left",fontSize: 12, fontWeight: 600, color: C.muted, borderBottom: `1px solid ${C.border}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {queueData.map((row, i) => (
                <tr key={i} style={{ borderBottom: `1px solid rgba(169,163,201,0.05)`, borderLeft: `3px solid ${row.priority === "Urgent" ? C.error : row.priority === "High" ? C.error : row.priority === "Medium" ? C.warning : C.success}` }}
                  onMouseEnter={e => e.currentTarget.style.background = "rgba(134,96,248,0.03)"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <td style={{ padding: "14px 16px" }}><input type="checkbox" checked={selected.includes(i)} onChange={() => toggleRow(i)} style={{ accentColor: C.accent }} /></td>
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <img src={row.avatar} style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }} alt="" />
                      <div><div style={{ fontWeight: 600,fontSize: 12 }}>{row.name}</div><div style={{fontSize: 12, color: C.muted }}>{row.empId} · {row.dept}</div></div>
                    </div>
                  </td>
                  <td style={{ padding: "14px 16px" }}><div style={{ fontWeight: 500,fontSize: 12 }}>{row.issue}</div><div style={{fontSize: 12, color: C.muted }}>{row.detail}</div></td>
                  <td style={{ padding: "14px 16px" }}><div style={{ fontWeight: 500,fontSize: 12 }}>{row.date}</div><div style={{fontSize: 12, color: C.muted }}>{row.day}</div></td>
                  <td style={{ padding: "14px 16px" }}><span style={{fontSize: 12, padding: "4px 10px", borderRadius: 20, background: `${row.srcColor}18`, color: row.srcColor, border: `1px solid ${row.srcColor}40` }}>{row.source}</span></td>
                  <td style={{ padding: "14px 16px" }}><StatusChip status={row.priority} /></td>
                  <td style={{ padding: "14px 16px" }}><StatusChip status={row.status} /></td>
                  <td style={{ padding: "14px 16px" }}><div style={{ fontSize: 12, fontWeight: 500 }}>{row.by}</div><div style={{fontSize: 12, color: C.muted }}>{row.ago}</div></td>
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                      {[["eye",C.muted],["check",C.success],["xmark",C.error],["clock",C.warning]].map(([icon,color]) => (
                        <button key={icon} style={{ width: 30, height: 30, borderRadius: "50%", ...s.elevated, border: "none", color, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <i className={`fa-solid fa-${icon}`} style={{fontSize: 12 }} />
                        </button>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 16px", borderTop: `1px solid ${C.border}` }}>
          <span style={{ fontSize: 12, color: C.muted }}>Showing 1–6 of 127 cases</span>
          <div style={{ display: "flex", gap: 6 }}>
            {["Previous","1","2","3","Next"].map((p, i) => (
              <button key={i} style={{ padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, border: "none", cursor: "pointer", background: p === "1" ? C.accent : C.elevated, color: p === "1" ? "#fff" : C.muted }}>{p}</button>
            ))}
          </div>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
        <div style={{ ...s.card, padding: 20 }}>
          <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-chart-pie" style={{ color: C.accent }} />Approval Analytics</div>
          {[["Approval Rate","87%",C.success,87],["Avg. Resolution Time","2.3h",C.accent,null],["Auto Resolved","68","#60A5FA",null]].map(([l,v,c,pct]) => (
            <div key={l} style={{ ...s.elevated, padding: 12, marginBottom: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: pct ? 8 : 0 }}>
                <span style={{ fontSize: 12, color: C.muted }}>{l}</span><span style={{ fontWeight: 700, color: c,fontSize: 12 }}>{v}</span>
              </div>
              {pct && <div style={{ height: 6, background: C.elevated, borderRadius: 4, overflow: "hidden" }}><div style={{ height: "100%", background: c, width: `${pct}%`, borderRadius: 4 }} /></div>}
            </div>
          ))}
        </div>
        <div style={{ ...s.card, padding: 20 }}>
          <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-robot" style={{ color: "#60A5FA" }} />Auto Fix Suggestions</div>
          <div style={{ ...s.elevated, padding: 12, borderLeft: `2px solid #60A5FA`, marginBottom: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}><span style={{fontSize: 12, fontWeight: 500 }}>Safe to Auto Approve</span><span style={{ fontWeight: 700, color: C.accent }}>68</span></div>
            <div style={{fontSize: 12, color: C.muted }}>Low risk cases with manager approval</div>
          </div>
          <div style={{ ...s.elevated, padding: 12, borderLeft: `2px solid ${C.warning}`, marginBottom: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}><span style={{fontSize: 12, fontWeight: 500 }}>Missing Punch Auto Fix</span><span style={{ fontWeight: 700, color: C.accent }}>23</span></div>
            <div style={{fontSize: 12, color: C.muted }}>Can be resolved using shift timings</div>
          </div>
          <button style={{ ...s.btnPrimary, width: "100%", justifyContent: "center" }}><i className="fa-solid fa-wand-magic-sparkles" />Run Auto Resolve</button>
        </div>
        <div style={{ ...s.card, padding: 20 }}>
          <div style={{ fontWeight: 600,fontSize: 12, marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}><i className="fa-solid fa-clock-rotate-left" style={{ color: C.muted }} />Recent Actions</div>
          {[["Approved 15 cases","By Admin · 10 mins ago"],["Rejected 3 late marks","By HR Manager · 25 mins ago"],["Auto resolved 45 cases","By System · 1 hour ago"],["Bulk approved Bangalore","By Admin · 2 hours ago"]].map(([a,b]) => (
            <div key={a} style={{ ...s.elevated, padding: 10, borderRadius: 8, marginBottom: 8 }}>
              <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 2 }}>{a}</div>
              <div style={{fontSize: 12, color: C.muted }}>{b}</div>
            </div>
          ))}
        </div>
      </div>
      {selected.length > 0 && (
        <div style={{ position: "fixed", bottom: 70, left: 0, right: 0, background: `linear-gradient(to right, ${C.accent}, #6b4cd4)`, padding: "14px 24px", zIndex: 99 }}>
          <div style={{ maxWidth: 1500, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <button onClick={() => setSelected([])} style={{ background: "transparent", border: "none", color: "#fff", cursor: "pointer",fontSize: 12 }}><i className="fa-solid fa-xmark" /></button>
              <span style={{ color: "#fff", fontWeight: 700,fontSize: 12 }}>{selected.length} Cases Selected</span>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              {["Hold All","Reject All"].map(l => <button key={l} style={{ padding: "10px 20px", borderRadius: 20, background: "rgba(255,255,255,0.15)", color: "#fff", border: "none", cursor: "pointer", fontWeight: 600,fontSize: 12 }}>{l}</button>)}
              <button style={{ padding: "10px 20px", borderRadius: 20, background: "#fff", color: C.accent, border: "none", cursor: "pointer", fontWeight: 700,fontSize: 12 }}>
                <i className="fa-solid fa-check-double" style={{ marginRight: 6 }} />Approve All
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "rgba(15,11,36,0.97)", backdropFilter: "blur(12px)", borderTop: `1px solid ${C.border}`, padding: "14px 24px", zIndex: 40 }}>
        <div style={{ maxWidth: 1500, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(245,158,11,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}><i className="fa-solid fa-clock" style={{ color: C.warning,fontSize: 12 }} /></div>
              <div>
                <div style={{ fontWeight: 700,fontSize: 12 }}>127 Cases Pending Review</div>
                <div style={{fontSize: 12, color: C.muted }}>Clear queue before payroll run · April 2026</div>
              </div>
            </div>
            <div style={{ display: "flex", gap: 16,fontSize: 12 }}>
              <span style={{ color: C.error }}><i className="fa-solid fa-circle-exclamation" /> 23 Urgent</span>
              <span style={{ color: "#60A5FA" }}><i className="fa-solid fa-robot" /> 68 Auto Fix</span>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button style={s.btnSecondary}><i className="fa-solid fa-wand-magic-sparkles" />Approve All Safe Cases</button>
            <button style={s.btnGhost}><i className="fa-solid fa-arrow-left" />Back to Inputs</button>
            <button style={{ ...s.btnSecondary, opacity: 0.5, cursor: "not-allowed" }}><i className="fa-solid fa-lock" />Proceed to Run Payroll</button>
          </div>
        </div>
      </div>
      <style>{`@keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.5; } }`}</style>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// ROOT
// ════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [activeTab, setActiveTab] = useState("inputs");

  const pages = {
    inputs: <AttendanceInputs />,
    detail: <DetailReview />,
    queue:  <ApprovalQueue />,
  };

  return (
    <div style={{ background: "var(--pay-bg)", color: "var(--pay-text)", height: "100vh", display: "flex", overflow: "hidden" }}>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

      {/* ── Hover-expand side nav — no isOpen prop needed ── */}
      <Nav activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* ── Main content ── */}
      <div style={{ flex: 1, minWidth: 0, overflow: "auto" }}>
        {pages[activeTab]}
      </div>

      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: var(--pay-surface); }
        ::-webkit-scrollbar-thumb { background: var(--pay-surface-2); border-radius: 4px; }
        ::-webkit-scrollbar-thumb:hover { background: #8660F8; }
        select option { background: var(--pay-surface-2); color: var(--pay-text); }
        @keyframes pulse-glow {
          0%,100% { box-shadow: 0 0 15px rgba(134,96,248,0.3); }
          50% { box-shadow: 0 0 28px rgba(134,96,248,0.6); }
        }
        @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.5; } }
      `}</style>
    </div>
  );
}